import { ApolloError } from '@apollo/client';
import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { parseBillingAccessError, redirectToBillingAccess } from '@services/billing-access';
import TravelErrorPanel from './travel-error-panel';

interface GraphqlErrorProps {
  error: ApolloError | undefined;
}

function GraphqlError({ error }: GraphqlErrorProps) {
  const billingAccessPayload = parseBillingAccessError(error);

  useEffect(() => {
    if (billingAccessPayload) {
      redirectToBillingAccess(billingAccessPayload);
      return;
    }

    Sentry.captureException(error, { extra: { error } });
    console.error('GraphqlError: ', error);
  }, [billingAccessPayload, error]);

  if (billingAccessPayload) {
    return null;
  }

  return <TravelErrorPanel />;
}

export default GraphqlError;
